import { render, staticRenderFns } from "./FormTests.vue?vue&type=template&id=67c3f9ec&"
import script from "./FormTests.vue?vue&type=script&lang=js&"
export * from "./FormTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports